<template>
  <PresentacionDraftDetailView path="draft" hideHistory draft
                    action-buttons-prefix="PresentacionDraftActionButtons">
  </PresentacionDraftDetailView>
</template>

<script>
import store from '../../../app/store'
import PresentacionDraftDetailView from '../components/PresentacionDraftDetailView.vue'

export default {
  components: {
    PresentacionDraftDetailView
  },

  beforeRouteEnter (to, from, next) {
    store.commit('hideLateralNav')
    next()
  }
}

</script>
